// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as EventsRouteImport } from './routes/events'
import { Route as EnquiryRouteImport } from './routes/enquiry'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedMyBookingsRouteImport } from './routes/_authenticated/my-bookings'
import { Route as AuthenticatedBookRouteImport } from './routes/_authenticated/book'
import { Route as AuthenticatedAiStudioRouteImport } from './routes/_authenticated/ai-studio'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const EnquiryRoute = EnquiryRouteImport.update({
            id: '/enquiry',path: '/enquiry',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedMyBookingsRoute = AuthenticatedMyBookingsRouteImport.update({
            id: '/my-bookings',path: '/my-bookings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBookRoute = AuthenticatedBookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAiStudioRoute = AuthenticatedAiStudioRouteImport.update({
            id: '/ai-studio',path: '/ai-studio',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedAiStudioRoute: AuthenticatedAiStudioRoute,AuthenticatedBookRoute: AuthenticatedBookRoute,AuthenticatedMyBookingsRoute: AuthenticatedMyBookingsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,BlogRoute: BlogRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DisclaimerRoute: DisclaimerRoute,EnquiryRoute: EnquiryRoute,EventsRoute: EventsRoute,GalleryRoute: GalleryRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)